var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "navbar" },
    [
      _c("hamburger", {
        staticClass: "hamburger-container",
        attrs: { "is-active": _vm.sidebar.opened },
        on: { toggleClick: _vm.toggleSideBar },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "right-menu" },
        [
          _c("span", [_vm._v(_vm._s(_vm.name))]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "text", round: "" },
              nativeOn: {
                click: function ($event) {
                  return _vm.logout($event)
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("logout")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }